import * as t from "io-ts";
import {WarningArrayValidator} from "./warning";

const nullableNumber = t.union([t.number, t.null]);
const nullableString = t.union([t.string, t.null]);

/** A shift's new totals from costing it. */
const ShiftCostShiftValidator = t.intersection([
  t.type({id: t.string}),
  t.partial({revenue: nullableNumber, cost: nullableNumber, lastModifiedDttm: nullableNumber}),
]);

/**
 * A costed ticket: its new cost lines, and the fields costing refreshed. The cost lines keep the shape of the
 * ticket's own `objectCostRateModelList`, so they are taken as given.
 */
const ShiftCostTicketValidator = t.intersection([
  t.type({id: t.string}),
  t.partial({
    database: nullableString,
    objectCostRateModelList: t.union([t.array(t.UnknownRecord), t.null]),
    billableTime: nullableNumber,
    refresh: t.union([t.UnknownRecord, t.null]),
  }),
]);

const ShiftCostActivityValidator = t.partial({
  startShift: t.union([ShiftCostShiftValidator, t.null]),
  transportTransportAssoc: t.union([ShiftCostTicketValidator, t.null]),
  warnings: t.union([WarningArrayValidator, t.null]),
});

/** `POST /reports/shift/{id}/cost`: only what costing changed, one shift or ticket per activity. */
export const ShiftCostResponseValidator = t.partial({
  activityList: t.union([t.array(ShiftCostActivityValidator), t.null]),
  diagnostics: t.unknown,
  warnings: nullableString,
});

export type ShiftCostResponse = t.TypeOf<typeof ShiftCostResponseValidator>;

export type ShiftCostRequest = {
  shiftId: string;
  /** Only these rate models are costed; every one when missing. */
  rateModelIds?: string[];
  /** Works the costs out without saving them, as for anyone but an admin. */
  preview?: boolean;
  /** Lets the costing's stages be followed at `/progress/{id}/details`. */
  progressId?: string;
};
